export default __webpack_public_path__ + "static/high-five-illustration-c6485648064b599e846b937c9d9f35fa.png";